import { DotsFilledIcon } from '@approvalmax/ui';
import { type BodyCellProps, Button, Dropdown, Menu } from '@approvalmax/ui/src/components';
import { selectors } from 'modules/common';
import { domain } from 'modules/data';
import { useDispatch, useSelector } from 'modules/react-redux';
import { FC, memo, useCallback } from 'react';
import { useToggle } from 'react-use';

import { showOffboardUserPopup } from '../../../../actions';
import { getManageUsersCommand } from '../../../../selectors/commandSelectors';
import { UserRow } from '../../UserList.types';
import { messages } from './UserMenuCell.messages';
import { HideableCell } from './UserMenuCell.styles';

const UserMenuCell: FC<BodyCellProps<UserRow>> = memo((props) => {
    const { item, hovered } = props;

    const dispatch = useDispatch();
    const company = useSelector(selectors.navigation.getActiveCompany);
    const me = useSelector(selectors.profile.getProfileUser);
    const manageUsersCommand = useSelector(getManageUsersCommand);
    const [dropdownOpen, dropdownpOpenToogle] = useToggle(false);

    const canDeleteUser =
        me.id !== item.id &&
        company.author !== item.id &&
        !(company.flags.isWorkflowManager && item.role !== domain.CompanyUserRole.Participant);

    const onMenuItemClick = useCallback(() => {
        dispatch(showOffboardUserPopup(item.id));
    }, [dispatch, item.id]);

    return (
        <HideableCell {...props} $hide={!hovered}>
            <Dropdown
                open={dropdownOpen}
                onOpen={dropdownpOpenToogle}
                closeOnClickInnerButton
                activator={
                    <Button noPadding icon variant='text' color='blue100'>
                        <DotsFilledIcon />
                    </Button>
                }
                width='max-content'
            >
                <Menu>
                    <Menu.Item
                        disabled={!canDeleteUser || manageUsersCommand.disabled}
                        name={messages.offboardButtonText}
                        onClick={onMenuItemClick}
                    />
                </Menu>
            </Dropdown>
        </HideableCell>
    );
});

export default UserMenuCell;
